import {
  // oxlint-disable-next-line @anchorage/restricted-syntax/no-legacy-icon-import -- CEXP-19074
  AlertOctagon,
  // oxlint-disable-next-line @anchorage/restricted-syntax/no-legacy-icon-import -- CEXP-19074
  CircleCheckOutlineIcon,
  // oxlint-disable-next-line @anchorage/restricted-syntax/no-legacy-icon-import -- CEXP-19074
  CircleInfoIcon,
  // oxlint-disable-next-line @anchorage/restricted-syntax/no-legacy-icon-import -- CEXP-19074
  CircleWarningIcon,
  // oxlint-disable-next-line @anchorage/restricted-syntax/no-legacy-icon-import -- CEXP-19074
  TriangleWarningIcon,
} from '@latitude/icons';
import { Spinner } from '@latitude/spinner';
import type { VariantProps } from 'class-variance-authority';
import type { toastVariants } from 'variants/toast-variants';

/**
 * Renders an icon based on the provided variant.
 *
 * @param variant - The variant of the toast.
 * @returns The rendered icon component.
 */
export const ToastIcon = ({ variant }: VariantProps<typeof toastVariants>) => {
  let Icon: typeof CircleCheckOutlineIcon;

  if (variant === 'loading') {
    return <Spinner size="medium" />;
  }

  switch (variant) {
    case 'success':
      Icon = CircleCheckOutlineIcon;
      break;
    case 'warning':
      Icon = TriangleWarningIcon;
      break;
    case 'danger':
      Icon = CircleWarningIcon;
      break;
    case 'alert':
      Icon = AlertOctagon;
      break;

    default:
      Icon = CircleInfoIcon;
      break;
  }
  return <Icon className="size-6 shrink-0 fill-current" />;
};
